import z from "zod";

export type BlogPostSummary = z.infer<typeof BlogPostSummarySchema>;
export const BlogPostSummarySchema = z.object({
  id: z.string().nonempty("Blog ID is required."),
  title: z.string().min(2).max(150, "Title must be between 2 and 150 characters."),
  thumbnail: z.string().url("Thumbnail URL must be valid.").optional(),

  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date()
});

export type BlogPost = z.infer<typeof BlogPostSchema>;
export const BlogPostSchema = BlogPostSummarySchema.extend({
  author: z.string().nonempty("Author is required."),
  content: z.string().min(10, "Content must be at least 10 characters long."),
  
  keywords: z.array(z.string()).optional(),
  relatedPosts: z.array(BlogPostSummarySchema).optional()
});